/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {RibbonPlacement, RibbonType, MultipleRibbonsLayout} from '../../constants';

export const getProductRibbonsCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const ribbonRectangleType = styleParams.numbers.productPage_ribbonType === RibbonType.RECTANGLE;
  const additionalRibbonRectangleType = styleParams.numbers.productPage_additionalRibbonType === RibbonType.RECTANGLE;

  return {
    productPage_ribbonPadding: ribbonRectangleType ? '2px 12px' : 'inherit',
    productPage_ribbonBackground: ribbonRectangleType ? styleParams.colors.productPage_ribbonBackground : 'inherit',
    productPage_ribbonBorder: ribbonRectangleType
      ? `${styleParams.numbers.productPage_ribbonBorderWidth}px solid ${styleParams.colors.productPage_ribbonBorderColor}`
      : 'none',
    productPage_additionalRibbonPadding: additionalRibbonRectangleType ? '2px 12px' : 'inherit',
    productPage_additionalRibbonBackground: additionalRibbonRectangleType
      ? styleParams.colors.productPage_additionalRibbonBackground
      : 'inherit',
    productPage_additionalRibbonBorder: additionalRibbonRectangleType
      ? `${styleParams.numbers.productPage_additionalRibbonBorderWidth}px solid ${styleParams.colors.productPage_additionalRibbonBorderColor}`
      : 'none',
    productPage_multipleRibbonsFlexDirection:
      styleParams.numbers.productPage_multipleRibbonsLayout === MultipleRibbonsLayout.Horizontal ? 'row' : 'column',
  };
};

export const getProductRibbonsShouldRenderVars = ({booleans, numbers}: ShouldRenderVarsFnParams) => {
  const primaryOnImage =
    booleans.productPage_showRibbon && numbers.productPage_ribbonPlacement === RibbonPlacement.OnImage;
  const primaryOnInfo =
    booleans.productPage_showRibbon && numbers.productPage_ribbonPlacement === RibbonPlacement.ProductInfo;
  const additionalOnImage =
    booleans.productPage_showAdditionalRibbons &&
    numbers.productPage_additionalRibbonPlacement === RibbonPlacement.OnImage;
  const additionalOnInfo =
    booleans.productPage_showAdditionalRibbons &&
    numbers.productPage_additionalRibbonPlacement === RibbonPlacement.ProductInfo;

  return {
    shouldShowRibbonOnImage: primaryOnImage,
    shouldShowRibbonOnProductInfo: primaryOnInfo,
    shouldShowAdditionalRibbonsOnImage: additionalOnImage,
    shouldShowAdditionalRibbonsOnProductInfo: additionalOnInfo,
    shouldShowAnyRibbonOnImage: primaryOnImage || additionalOnImage,
    shouldShowAnyRibbonOnProductInfo: primaryOnInfo || additionalOnInfo,
  };
};
